import { WorkspaceSettingDialog } from '@web/app/features/home/components';

import { ServiceDetailDialog } from '../../service-detail-dialog';
import { WorkspacePendingDialog } from '../../workspace-pending-dialog';

/**
 * Renders global dialogs that are triggered via Zustand stores.
 * Extracted from Header to reduce component complexity.
 */
export const DialogHost = () => {
    return (
        <>
            <WorkspacePendingDialog />
            <ServiceDetailDialog />
            <WorkspaceSettingDialog />
        </>
    );
};
